<template>
  <el-card class="h-full absolute inset-0 z-10">
    <div class="h-full flex flex-col">
      <span
        v-if="!(formProps.editType === 'read')"
        class="border-l-3 border-color-primary pl-10px text-18px"
        >作业活动隐患排查清单编辑</span
      >
      <div v-else>
        <el-page-header @back="$emit('cancel')" content="作业活动隐患排查清单详情"></el-page-header>
      </div>
      <div class="flex-1 overflow-y-auto mt-20px">
        <el-collapse v-model="collapseActiveName">
          <el-collapse-item title="风险点基本信息" name="baseInfo">
            <el-form ref="form" disabled label-width="150px" :model="formData">
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="作业活动名称" prop="jobName">
                    <el-input v-model="formData.jobName" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="作业活动内容" prop="jobContent">
                    <el-input v-model="formData.jobContent" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="作业活动类型" prop="jobActivityType">
                    <el-select
                      v-model="formData.jobActivityType"
                      placeholder="请选择作业类型"
                      clearable
                      class="w-full"
                    >
                      <el-option
                        v-for="item in jobTypeList"
                        :key="item.value"
                        :label="item.displayName"
                        :value="Number(item.code)"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="作业活动编号" prop="jobNo">
                    <el-input v-model="formData.jobNo" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="作业活动区域" prop="jobActivityAreaStr">
                    <el-input v-model="formData.jobActivityAreaStr" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="作业实施单位" prop="jobImplementationUnitStr">
                    <el-input
                      v-model="formData.jobImplementationUnitStr"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="作业活动频率" prop="jobActivityFrequencyText">
                    <el-input
                      v-model="formData.jobActivityFrequencyText"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="涉及设备设施" prop="equipmentStr">
                    <el-input v-model="formData.equipmentStr" show-word-limit></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="管控层级" prop="controlHierarchyText">
                    <el-input v-model="formData.controlHierarchyText" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="责任部门" prop="organizationUnitName">
                    <el-input v-model="formData.organizationUnitName" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="责任人" prop="leaderName">
                    <el-input v-model="formData.leaderName" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="风险等级" prop="riskLevelName">
                    <el-input :value="computerRiskLevelName" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>
        </el-collapse>
        <CheckListInfo
          :formProps="formProps"
          ref="checkListInfo"
          :dataList="rowData.jobSourcesDangerIdentifyAssessDtos"
          type="job"
        ></CheckListInfo>
      </div>
      <div class="flex justify-center mt-20px" v-if="formProps.editType !== 'read'">
        <el-button type="primary" size="small" @click="submitForm('save')" :loading="loading"
          >保存</el-button
        >
        <el-button @click="$emit('cancel')" size="small">取消</el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import { HiddenDangerInspectionChecklistControllApi } from '@wiz-api/double-prevention-management'
import dayjs from 'dayjs'
import { riskList } from '@/components/safety/enumField/enumTagType'
import utils from '@/components/safety/enumField/utils'
import CheckListInfo from '../business/CheckListInfo'

const hiddenDangerInspectionChecklistControllApi = new HiddenDangerInspectionChecklistControllApi()
export default {
  name: 'check-list-equip-form',
  components: {
    CheckListInfo,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    formProps: {
      default: () => {
        return {
          title: '',
          editType: 'create',
          visible: true,
        }
      },
    },
  },
  computed: {
    computerRiskLevelName() {
      const list = this.formData.jobSourcesDangerIdentifyAssessDtos
      return list.reduce((pre, item) => {
        if (pre.label) {
          const obj = riskList.find((i) => {
            return i.label === item.controlLevel
          })
          if (obj) {
            return obj.value > pre.label ? obj : pre
          }
          return pre
        }
        const firstObj = riskList.find((i) => {
          return i.label === item.controlLevel
        })
        return firstObj || {}
      }, {})?.label
    },
  },
  data() {
    return {
      jobTypeList: [],
      rowData: {},
      taskList: [1, 2],
      tableData: [],
      list: [],
      loading: false,
      collapseActiveName: ['baseInfo', 'risk', 'riskLevelControl'],
      controlHierarchyList: [],
    }
  },
  watch: {},
  created() {
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.JobActivityType',
        'DoublePreventionManagement.DataCategory.ControlHierarchy',
      ],
      ['jobTypeList', 'controlHierarchyList'],
      this
    )
    this.rowData = JSON.parse(JSON.stringify(this.formData))
  },
  mounted() {},
  methods: {
    async submitForm(type) {
      const data = this.$refs.checkListInfo.getData()
      if (data) {
        this.loading = true
        data.forEach((item) => {
          item.inspectionCycle = `${item.inspectionCycle}`
          const list = item.sourcesDangerRecognitionRiskAssessControlDtos
          if (list && list.length) {
            list.forEach((i) => {
              if (i.creationTime) {
                i.creationTime = dayjs(i.creationTime).format('YYYY-MM-DD HH:mm:ss')
              }
              if (i.lastModificationTime) {
                i.lastModificationTime = dayjs(i.lastModificationTime).format('YYYY-MM-DD HH:mm:ss')
              }
              if (i.deletionTime) {
                i.deletionTime = dayjs(i.deletionTime).format('YYYY-MM-DD HH:mm:ss')
              }
            })
          }
        })
        this.formData.jobSourcesDangerIdentifyAssessDtos = data
        const [err, res] = await hiddenDangerInspectionChecklistControllApi.saveJobActivityData({
          body: this.formData,
        })
        if (!err) {
          this.$emit('refreshList')
          this.$emit('cancel')
        }
        this.loading = false
      }
    },
    createRow() {
      // this.$refs.riskIdentify.createRow()
      this.$refs.controlMeasure.createRow()
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-icon-arrow-right {
  display: none;
}
</style>
